import React, {useEffect, useState} from 'react';
import OptimizationTable from "../../../../components/UI/table/optimization/optimization/OptimizationTable";
import OptimizationService from "../../../../API/orders/optimization/organization/OptimizationService";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../../Constants";
import ModalConfirm from "../../../../components/UI/modal/ModalConfirm";
import {calcFilterData} from "../../../../utils/common/calcFilterData";
import OrderUtil from "../../../../utils/orders/OrderUtil";
import {optimizationStateStatuses} from "../../../../data/OptizationState";
import {OptimizationsFilterData} from "../../../../data/FilterTables/OptimizationsFilterData";

const modalActions = [
    {name: "Отправить в архив", type: "archive"},
]

const Optimizations = () => {
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false)
    const [createCuttingMapsModalOpen, setCreateCuttingMapsModalOpen] = useState(false);
    const [alertData, setAlertData] = useState({});
    const [statusList, setStatusList] = useState([]);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/optimizations`, "pageSize", nextState.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OptimizationsFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OptimizationsFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/optimizations`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/optimizations`]?.pageSize
        const searchQuery = pagesData[`organization/optimizations`]?.searchQuery

        return {searchQuery, pageSize}
    }


    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const handleSelectAction = () => {
        setOpen(false)
        setCreateCuttingMapsModalOpen(true)
    }

    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        OptimizationService.getAllNotArchive().then(function (response) {
            let data = response.data;
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setStatusList(OrderUtil.getListFieldByEnum(data, 'optimizationState', optimizationStateStatuses));
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const selectedOptimizations = data.filter(item => rowSelection.includes(item.id));
    const isSingleSelection = selectedOptimizations.length === 1;
    const getOptimizationNumber = (item) => item.number ?? 'не занумерован';

    const getConfirmModalTitle = () => "Подтвердить отправку в архив?";

    const renderConfirmModalContent = () => {
        if (selectedOptimizations.length === 0) {
            return null;
        }

        if (isSingleSelection) {
            return (
                <Typography>
                    Вы подтверждаете отправку в архив оптимизации {getOptimizationNumber(selectedOptimizations[0])}
                </Typography>
            );
        }

        return (
            <>
                <Typography sx={{mb: 1}}>
                    Вы подтверждаете отправку в архив оптимизаций:
                </Typography>
                <Box component="ul" sx={{m: 0, pl: 2.5}}>
                    {selectedOptimizations.map((item) => (
                        <Typography component="li" key={item.id}>
                            {getOptimizationNumber(item)}
                        </Typography>
                    ))}
                </Box>
            </>
        );
    };

    const handleSubmit = async () => {
        OptimizationService.setArchive(rowSelection)
            .then(function () {
                const newData = data.filter(el => {
                    return !rowSelection.includes(el.id)
                })
                setData(newData);
                handleSearchQuery(globalFilter, newData)
                setCreateCuttingMapsModalOpen(false)
                setRowSelection([])
                handleModalAlert("Отправлено в архив", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Оптимизации"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Оптимизации
                    </Typography>
                </Box>
                <OptimizationTable
                    data={data}
                    setData={setData}
                    isCreateCreateOptimization={true}
                    isRedirectPlans={true}
                    isCalculation={false}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    statusList={statusList}
                />

                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                    autoHide={false}
                />
                <ModalConfirm
                    title={getConfirmModalTitle()}
                    modalOpen={createCuttingMapsModalOpen}
                    handleClose={() => setCreateCuttingMapsModalOpen(false)}
                    handleSubmit={handleSubmit}
                    action={"Подтвердить"}>
                    {renderConfirmModalContent()}
                </ModalConfirm>
            </Box>
        </Box>
    );
};

export default Optimizations;